module.exports = "/_next/static/images/map-bg-717f3fb4d2020846678f791050ef2ac9.png.webp";